import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { SortingState, VisibilityState } from '@tanstack/react-table';

interface FullPageTableState {
  columnVisibility: VisibilityState;
  sorting: SortingState;
}

interface FullPageTableActions {
  setColumnVisibility: (columnVisibility: VisibilityState) => void;
  setSorting: (sorting: SortingState) => void;
}

type FullPageTableStore = FullPageTableState & FullPageTableActions;

export function createFullPageTableStore(
  storeName: string,
  defaultColumnVisibility: VisibilityState = {},
  defaultSorting: SortingState = []
) {
  return create<FullPageTableStore>()(
    persist(
      (set) => ({
        columnVisibility: defaultColumnVisibility,
        sorting: defaultSorting,
        setColumnVisibility: (columnVisibility) => set({ columnVisibility }),
        setSorting: (sorting) => set({ sorting }),
      }),
      {
        name: storeName,
        storage: createJSONStorage(() => localStorage),
      }
    )
  );
}

export function useFullPageTableState(
  storeName: string,
  defaultColumnVisibility: VisibilityState = {},
  defaultSorting: SortingState = []
) {
  const store = createFullPageTableStore(storeName, defaultColumnVisibility, defaultSorting);
  return store();
}